// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lazy-select_contorl .el-select__tags .el-tag{max-width:90px;overflow:hidden;text-overflow:ellipsis}", ""]);
// Exports
module.exports = exports;
